module.exports = __webpack_public_path__ + "static/media/chris-cox-home-warranty-review_160px.8b59df6b.jpg";